export { ProductDetail } from './ProductDetail';
export { RelatedProductPlaceholder } from './RelatedProductPlaceholder';
export { ProductInfoPlaceholder } from './ProductInfoPlaceholder';
export { ProductBadges } from './ProductBadges';
